import React, { Fragment } from 'react';
import TableData from './TableData';
import TabBar from '../../../../Components/TabBar';
import TabItem from '../../../../Components/TabItem';
import IconBtn from '../../../../Components/IconBtn';
import LegendItem from './LegendItem';
import styles from '../Sunburst.module.css';
import { getFormattedNumber, getFormattedPercent } from '../../../../Util/numberFormats';

export default function DataArcSelected({
	tunnelData,
	totalLevel1Sessions,
	setActiveTab,
	selectedJourneyData,
	handleArcClick,
	activeTab,
	handleDeselect
}) {
	
	if(!selectedJourneyData) return <></>;
	
	function itemIsSelected(item) {
		if (selectedJourneyData.name !== item.name) return false;
		if (selectedJourneyData.level !== item.depth) return false;
		return true;
	}

	function itemHasTabs(item) {
		const isSelected = itemIsSelected(item);
		if (!isSelected) return false;
		if (!selectedJourneyData) return false;
		if (selectedJourneyData.name === 'Site exit' || selectedJourneyData.name === 'LostSession') return false;
		return true;
	}

	const last = tunnelData[tunnelData.length - 1];
	const totalSessionNumber = last?.data?.sessionCount ?? last?.value ?? 0;
	const totalPercent = totalLevel1Sessions > 0 ? ((totalSessionNumber / totalLevel1Sessions) * 100) : 0;

	return (
		<>
			<div className={styles.sidebar_header}>
				<div className='flex'>
					<div className='flex_item_fix'>
						<IconBtn
							icon="fas fa-arrow-left"
							onClick={handleDeselect}
							size="l"
							className={styles.sidebar_arrow}
							theme="dark"
						/>
					</div>
					<div className='flex_item_full'>
						<h3>Selected journey</h3>
						{tunnelData.length > 0 && (
							<div className='mt_3 s_14 grey_2'>
								{getFormattedNumber(totalSessionNumber)} sessions
								<span className='dot'></span>
								{getFormattedPercent(totalPercent)} of total
							</div>
						)}
					</div>
				</div>
			</div>
			<div className={styles.tunnel_list}>
				{tunnelData
					.filter(item => item.depth !== 0)
					.sort((a, b) => {
						return (a.depth ?? a.level ?? 0) - (b.depth ?? b.level ?? 0);
					})
					.map((item, idx) => {
						const isExit = item.name === 'Site exit' || item.name === 'LostSession';
						const hasTabs = itemHasTabs(item);
						const isSelected = itemIsSelected(item);
						return (
							<Fragment key={item.name + '-' + idx}>
								{idx > 0 && 
									<div className={styles.tunnel_arrow}>
										<i className={['fas fa-arrow-alt-circle-down', styles.tunnel_arrow_icon].join(' ')}></i>
									</div>
								}
								<LegendItem
									onClick={isExit ? undefined : (() => handleArcClick && handleArcClick(item.node ? item.node : item))}
									isClickable={!isExit && !isSelected}
									item={item}
									isTunnel={true}
									totalLevel1Sessions={totalLevel1Sessions}
									children={hasTabs ?
										<ItemTabs
											selectedJourneyData={selectedJourneyData}
											activeTab={activeTab}
											setActiveTab={setActiveTab}
										/> : null
									}
								/>
							</Fragment>
						);
					})}
			</div>
		</>
	);
}

function ItemTabs({
	selectedJourneyData,
	activeTab,
	setActiveTab
}) {

	return (
		<div className={styles.legend_item_tabs}>
			<TabBar size="s">
				<TabItem
					message='Top URLs'
					onClick={() => setActiveTab('urls')}
					selected={activeTab === 'urls'}
				/>
				<TabItem
					message='Traffic sources'
					onClick={() => setActiveTab('trafficSources')}
					selected={activeTab === 'trafficSources'}
				/>
				<TabItem
					message='Engagement level'
					onClick={() => setActiveTab('visitorEngagement')}
					selected={activeTab === 'visitorEngagement'}
				/>
			</TabBar>
			{activeTab === 'urls' && (
				<TableData
					id="topUrls"
					data={selectedJourneyData?.topUrls}
				/>
			)}
			{activeTab === 'trafficSources' && (
				<TableData
					id="topTraffics"
					data={selectedJourneyData?.trafficSources}
				/>
			)}
			{activeTab === 'visitorEngagement' && (
				<TableData
					id="topVisEngLevels"
					data={selectedJourneyData?.VisEngLevels}
				/>
			)}
		</div>
	);
}
